<template lang="pug">
  b-row.mb-5
    b-col
      router-view(@contact-changed='reloadOrganizationsPanel')
</template>

<script>
export default {
  name: 'manager-organizations-contact',
  methods: {
    reloadOrganizationsPanel() {
      this.$parent.$refs.organizationsPanel.panelReload()
    },
  },
}
</script>
